export class DmdpHttpHeaderConst {
  static AUTHORIZATION = 'Authorization';
  static HMAC_DMDP_TIMESTAMP = 'dmdp-timestamp';
  static HMAC_DMDP_NONCE = 'dmdp-nonce';
  static TRACE_ID = 'X-B3-TraceId';
  static SPAN_ID = 'X-B3-SpanId';
  static X_CLIENT_ID = 'X-Client-Id';
  static BOOST_DC_ID = 'boost-dc-id';
}
